import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetGroupings,
  SaveGrouping,
  CreateGrouping,
  DeleteGrouping,
  DeleteGroupingValue,
  EditGroupingValues,
  CreateGroupingValues,
  UpdateGroupingName
};

function GetGroupings(contractId, versionId, editionId, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteriagroups`,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      console.log(error);
      onError(error);
    });
}

function SaveGrouping(contractId, versionId, editionId, grouping, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteriagroups/${
          grouping.id
        }`,
      grouping,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function UpdateGroupingName(contractId, versionId, editionId, groupingId, groupingObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteriagroups/${groupingId}`,
      groupingObject,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}

function EditGroupingValues(
  contractId,
  versionId,
  editionId,
  groupingId,
  groupingValues,
  groupEntryName,
  originalgroupEntryName,
  order,
  onSuccess,
  onError
) {
  var headers = getAuthHeader();
  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteriagroups/${groupingId}/groupedentries/${groupEntryName}?groupOldName=${originalgroupEntryName}&order=${order}`,
      groupingValues,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}

function CreateGroupingValues(contractId, versionId, editionId, groupingId, groupingValues, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteriagroups/${groupingId}/groupedentries`,
      groupingValues,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}

function CreateGrouping(contractId, versionId, editionId, grouping, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteriagroups`,
      grouping,
      headers
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteGroupingValue(contractId, versionId, editionId, groupId, groupingName, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteriagroups/${groupId}/groupedentries/${groupingName}`,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}

function DeleteGrouping(contractId, versionId, editionId, groupingId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteriagroups/${groupingId}`,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch((error) => {
      onError(error);
    });
}
